import { changeVideoUrlHost } from "@/lib/news_helpers";
import Image from "next/image";

export function ImageCard({id, url, alt}: {
    id: string;
    url?: string;
    alt: string;
}){
    if(!url){
        return (
            <div className="relative w-full bg-gray-200 aspect-[4/3]">
                    <div className='flex items-center justify-center w-full h-full bg-gray-300 text-gray-500'>
                        No image available
                    </div>
                </div>
            )
        }
    const imageUrl = changeVideoUrlHost(url);
    return (
        <div className="relative w-full bg-gray-200 aspect-[4/3]">
            <Image
                id={id}
                src={imageUrl}
                fill
                alt={alt}
                className='object-contain'
                // This is the page's largest element. next/image defaults to
                // loading="lazy", which kept the LCP image out of the preload
                // scanner and off the critical path (3.4s LCP on image posts,
                // Search Console Oct 2026). priority preloads it instead.
                priority
            />
        </div>
    )
}